import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const usePageMeta = (title, description, { noindex = false, image = null } = {}) => {
    const { pathname } = useLocation();
    useEffect(() => {
        if (title) document.title = title;
        const setMeta = (selector, attr, val) => {
            const el = document.querySelector(selector);
            if (el && val) el.setAttribute(attr, val);
        };
        setMeta('meta[name="description"]', "content", description);
        setMeta('meta[property="og:title"]', "content", title);
        setMeta('meta[property="og:description"]', "content", description);
        if (image)
            setMeta('meta[property="og:image"]', "content", `https://titanhavengroup.com${image}`);
        let robots = document.querySelector('meta[name="robots"]');
        if (!robots) {
            robots = document.createElement("meta");
            robots.setAttribute("name", "robots");
            document.head.appendChild(robots);
        }
        robots.setAttribute("content", noindex ? "noindex, follow" : "index, follow");
        let canonical = document.querySelector('link[rel="canonical"]');
        if (noindex) {
            // Nonexistent/utility routes must not self-canonicalize (soft-404 defense).
            if (canonical) canonical.remove();
            return;
        }
        const url = `https://titanhavengroup.com${pathname}`;
        setMeta('meta[property="og:url"]', "content", url);
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }
        canonical.setAttribute("href", url);
    }, [title, description, pathname, noindex, image]);
};
